import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
import AOS from "aos";
import "aos/dist/aos.css";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
import VerticalAds from "../../Admin/Pages/VerticleAds";
export default function Machine() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);
  const navigate = useNavigate();
  const location = useLocation();

  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [searchState, setSearchState] = useState("");
  const [price, setPrice] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [wishlist, setWishlist] = useState([]);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(40);

  // Helper to reset all filters
  const clearAllFilters = () => {
    setSearch("");
    setSearchState("");
    setPrice("");
    setMinPrice("");
    setMaxPrice("");
    setCurrentPage(1);
  };

  const fetchMachines = useCallback(async (showLoading = true) => {
    if (showLoading) {
      setLoading(true);
    }

    try {
      const res = await fetch(
        `${API.LIST_MACHINES}&status=Active&t=${new Date().getTime()}`,
      );

      const data = await res.json();

      setProducts(Array.isArray(data) ? data : []);
    } catch (error) {
      console.log("Fetch Error:", error);
      setProducts([]);
    } finally {
      if (showLoading) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    // First page load → show loading
    fetchMachines(true);

    // Background refresh → no loading
    const interval = setInterval(() => {
      fetchMachines(false);
    }, 5000);

    // Window focus → show loading
    const handleFocus = () => {
      fetchMachines(true);
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", handleFocus);
    };
  }, [fetchMachines]);
  const loadUserAndWishlist = useCallback(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));
    setUser(loginUser);
    if (loginUser) {
      const savedWishlist =
        JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
      setWishlist(savedWishlist);
    } else {
      setWishlist([]);
    }
  }, []);

  useEffect(() => {
    loadUserAndWishlist();
    window.addEventListener("cartUpdated", loadUserAndWishlist);
    window.addEventListener("storage", loadUserAndWishlist);
    return () => {
      window.removeEventListener("cartUpdated", loadUserAndWishlist);
      window.removeEventListener("storage", loadUserAndWishlist);
    };
  }, [loadUserAndWishlist]);

  /* FILTER LOGIC */
  useEffect(() => {
    let filtered = [...products];

    if (search) {
      filtered = filtered.filter((item) =>
        item.city?.toLowerCase().includes(search.toLowerCase()),
      );
    }

    if (searchState) {
      filtered = filtered.filter((item) =>
        item.state?.toLowerCase().includes(searchState.toLowerCase()),
      );
    }

    if (minPrice) {
      filtered = filtered.filter(
        (item) => Number(item.price) >= Number(minPrice),
      );
    }
    if (maxPrice) {
      filtered = filtered.filter(
        (item) => Number(item.price) <= Number(maxPrice),
      );
    }

    setFilteredProducts(filtered);
  }, [search, searchState, price, products, minPrice, maxPrice]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentMachines = filteredProducts.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(1);
    }
  }, [filteredProducts, itemsPerPage, totalPages, currentPage]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleLike = (machine) => {
    if (!user) {
      alert("Please login first");
      return;
    }
    const storageKey = `wishlist_${user.id}`;
    let updatedWishlist = [...wishlist];
    const exists = updatedWishlist.find((item) => item.id === machine.id);

    if (exists) {
      updatedWishlist = updatedWishlist.filter(
        (item) => item.id !== machine.id,
      );
    } else {
      updatedWishlist.push({ ...machine, type: "machine" });
    }

    setWishlist(updatedWishlist);
    localStorage.setItem(storageKey, JSON.stringify(updatedWishlist));
    window.dispatchEvent(new Event("cartUpdated"));
  };
  const [imageIndexes, setImageIndexes] = useState({});
  const nextImage = (e, item, images) => {
    e.stopPropagation();

    const current = imageIndexes[item.id] || 0;

    if (current >= images.length - 1) {
      navigate(`/productdetails/${item.id}`);
      return;
    }

    setImageIndexes((prev) => ({
      ...prev,
      [item.id]: current + 1,
    }));
  };

  const prevImage = (e, item) => {
    e.stopPropagation();

    const current = imageIndexes[item.id] || 0;

    if (current === 0) return;

    setImageIndexes((prev) => ({
      ...prev,
      [item.id]: current - 1,
    }));
  };

  const getPagination = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Always show first page
    pages.push(1);

    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    // Near beginning
    if (currentPage <= 3) {
      start = 2;
      end = 5;
    }

    // Near end
    if (currentPage >= totalPages - 2) {
      start = totalPages - 4;
      end = totalPages - 1;
    }

    if (start > 2) {
      pages.push("...");
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 1) {
      pages.push("...");
    }

    // Always show last page
    pages.push(totalPages);

    return pages;
  };
  return (
    <div className="shop-page container-fluid py-4">
      <div className="row">
        {/* LEFT FILTER (Desktop) */}
        <div className="col-lg-2 d-none d-lg-block" data-aos="fade-right">
          <div className="filter-sidebar shadow-sm p-3 bg-white rounded sticky-top">
            {/* <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Filters</h5>
              <button
                className="btn btn-sm text-danger p-0"
                onClick={clearAllFilters}
                style={{ fontSize: "0.8rem", fontWeight: "600" }}
              >
                CLEAR ALL
              </button>
            </div> */}

            <div className="d-flex justify-content-between align-items-center mb-4 filter-header-border">
              <h5 className="mb-0 fw-bold text-secondary text-uppercase tracking-wider fs-6">
                Filters
              </h5>
              <button className="btn-uniq-reset" onClick={clearAllFilters}>
                Clear All
              </button>
            </div>

            <div className="mt-3">
              <h6 className="small fw-bold">Custom Price</h6>
              <input
                type="number"
                placeholder="Min Price"
                className="form-control mb-2 form-control-sm"
                value={minPrice}
                onChange={(e) => setMinPrice(e.target.value)}
              />
              <input
                type="number"
                placeholder="Max Price"
                className="form-control form-control-sm"
                value={maxPrice}
                onChange={(e) => setMaxPrice(e.target.value)}
              />
            </div>

            <div className="filter-box mt-4">
              <h6 className="small fw-bold">City</h6>
              <input
                type="text"
                placeholder="Search City"
                className="form-control form-control-sm"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <div className="filter-box mt-4">
              <h6 className="small fw-bold">State</h6>
              <input
                type="text"
                placeholder="Search State"
                className="form-control form-control-sm"
                value={searchState}
                onChange={(e) => setSearchState(e.target.value)}
              />
            </div>
            <div className="sidebar-ad">
              <div className="small text-center fw-bold p-1">SPONSORED</div>

              <VerticalAds />
            </div>
          </div>
        </div>

        {/* MOBILE HORIZONTAL FILTER */}
        <div className="d-lg-none mb-3 px-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="small fw-bold text-muted">Quick Filters</span>
            <button
              className="btn btn-sm btn-link text-danger p-0"
              onClick={clearAllFilters}
            >
              Clear All
            </button>
          </div>
          <div className="mobile-filter-bar d-flex gap-2 overflow-auto pb-2">
            <input
              type="number"
              placeholder="Min ₹"
              className="form-control form-control-sm"
              style={{ minWidth: "100px" }}
              value={minPrice}
              onChange={(e) => setMinPrice(e.target.value)}
            />
            <input
              type="number"
              placeholder="Max ₹"
              className="form-control form-control-sm"
              style={{ minWidth: "100px" }}
              value={maxPrice}
              onChange={(e) => setMaxPrice(e.target.value)}
            />
            <input
              type="text"
              placeholder="City"
              className="form-control form-control-sm"
              style={{ minWidth: "100px" }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <input
              type="text"
              placeholder="State"
              className="form-control form-control-sm"
              style={{ minWidth: "100px" }}
              value={searchState}
              onChange={(e) => setSearchState(e.target.value)}
            />
          </div>
        </div>

        {/* PRODUCTS GRID */}
        <div className="col-lg-10">
          <div
            className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2"
            data-aos="fade-down"
          >
            <h2 className="section-title mb-0">Embroidery Machines</h2>
            <div className="d-flex align-items-center gap-2">
              <span className="small text-muted">Show:</span>
              <select
                className="form-select form-select-sm"
                style={{ width: "80px" }}
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(parseInt(e.target.value))}
              >
                <option value={20}>20</option>
                <option value={40}>40</option>
                <option value={60}>60</option>
                <option value={100}>100</option>
              </select>
            </div>
          </div>

          {loading ? (
            <div className="machine-loading-container">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>

              <p className="mt-3 mb-0 text-muted">
                Loading embroidery machines...
              </p>
            </div>
          ) : (
            <div className="designs-grid">
              {currentMachines.length > 0 ? (
                currentMachines.map((item, index) => {
                  const images = item.image ? item.image.split(",") : [];
                  const isLiked = wishlist.some((w) => w.id === item.id);

                  return (
                    <div
                      className="design-card"
                      key={item.id}
                      onClick={() => navigate(`/productdetails/${item.id}`)}
                      data-aos="zoom-in-up"
                      data-aos-delay={(index % 8) * 70}
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        className="machine-img-container"
                        onClick={() => navigate(`/productdetails/${item.id}`)}
                      >
                        <img
                          src={`${UPLOADS.MACHINE_IMAGE}${item.user_id}/${
                            images[imageIndexes[item.id] || 0]
                          }?t=${Date.now()}`}
                          alt={item.machine_name}
                        />
                        {images.length > 1 && (
                          <>
                            {(imageIndexes[item.id] || 0) > 0 && (
                              <button
                                className="img-arrow left-arrow"
                                onClick={(e) => prevImage(e, item)}
                              >
                                <i className="bi bi-chevron-left"></i>
                              </button>
                            )}

                            <button
                              className="img-arrow right-arrow"
                              onClick={(e) => nextImage(e, item, images)}
                            >
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </>
                        )}
                        {images.length > 1 && (
                          <div className="image-count">
                            <i className="bi bi-images me-1"></i>+
                            {images.length - 1}
                          </div>
                        )}
                        <span className="heads-badge">
                          {item.NoOfHeads} Heads
                        </span>
                      </div>

                      <div className="machine-body">
                        <div className="machine-type">
                          <h4 className="machine-name">{item.machine_name}</h4>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {Number(item.price).toLocaleString("en-IN")}
                            </span>
                          </div>
                        </div>
                        <div className="spec-row mb-0">
                          <div className="spec-item">
                            <span className="spec-label">Brand:</span>
                            <span className="spec-value">{item.brand}</span>
                          </div>
                          <div className="spec-item">
                            <span className="spec-label">Area:</span>
                            <span className="spec-value">{item.Area}</span>
                          </div>
                        </div>
                        <div className="spec-item mt-0 p-1">
                          <span className="spec-label1">
                            {" "}
                            <i className="bi bi-person-fill me-2"></i>
                            {item.name}
                          </span>
                        </div>
                        <div className="location-info mb-0 p-1 pt-0">
                          <i className="bi bi-geo-alt-fill"></i> {item.city},{" "}
                          {item.state}
                        </div>

                        <div className="machine-footer mt-0">
                          <button
                            className="more-details-btn"
                            onClick={(e) => {
                              e.stopPropagation();

                              navigate(`/productdetails/${item.id}`, {
                                state: {
                                  activeTab: "seller",
                                },
                              });
                            }}
                          >
                            <i className="bi bi-telephone-fill me-1"></i>
                            Contact Supplier
                          </button>
                          <button
                            className="footer-like-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleLike(item);
                            }}
                          >
                            <i
                              className={`bi ${isLiked ? "bi-heart-fill text-danger" : "bi-heart"}`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center w-100 py-5">
                  <i
                    className="bi bi-search text-muted mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>

                  <p className="text-muted">
                    No machines found matching your criteria.
                  </p>

                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={clearAllFilters}
                  >
                    Clear all filters
                  </button>
                </div>
              )}
            </div>
          )}
          {/* PAGINATION */}
          {/* {totalPages > 1 && (
            <nav className="d-flex justify-content-center mt-5">
              <ul className="pagination custom-pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </li>
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i + 1}
                    className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => paginate(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                  >
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          )} */}

          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-5">
              <ul className="pagination uniq-pagination-wrapper shadow-sm p-1 rounded-pill bg-white">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link rounded-pill"
                    onClick={() => paginate(currentPage - 1)}
                  >
                    &lsaquo; Previous
                  </button>
                </li>

                {getPagination().map((page, index) =>
                  page === "..." ? (
                    <li key={`dots-${index}`} className="page-item disabled">
                      <span className="page-link border-0 bg-transparent">
                        ...
                      </span>
                    </li>
                  ) : (
                    <li
                      key={page}
                      className={`page-item ${
                        currentPage === page ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link rounded-circle"
                        onClick={() => paginate(page)}
                      >
                        {page}
                      </button>
                    </li>
                  ),
                )}

                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link rounded-pill"
                    onClick={() => paginate(currentPage + 1)}
                  >
                    Next &rsaquo;
                  </button>
                </li>
              </ul>
            </div>
          )}
          <HorizontalAds />
        </div>

        {/* RIGHT ADS */}
        {/* <div className="col-lg-2">
          <div className="ads-sidebar p-3 bg-white shadow-sm rounded text-center sticky-top">
            <h5 className="ads-title">Sponsored</h5>
            <div className="ad-card mt-3">
              <div className="ad-placeholder">
                <p className="small text-muted">Your Ad Here</p>
              </div>
              <p className="small mt-2">Premium Threads Sale!</p>
            </div>
          </div>
        </div> */}
      </div>

      <style>{`
        .custom-pagination .page-link {
          color: #00a699;
          border: 1px solid #dee2e6;
          margin: 0 3px;
          border-radius: 4px;
          font-weight: 500;
        }
        .custom-pagination .page-item.active .page-link {
          background-color: #00a699;
          border-color: #00a699;
          color: white;
        }
        .custom-pagination .page-link:hover {
          background-color: #f1f1f1;
          color: #00847a;
        }
        .mobile-filter-bar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
}
